import(/* webpackMode: "eager" */ "/home/cloudpub/frontend/src/app/global-error.tsx");
